<template>
  <div class="express-management">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="快递单号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入快递单号" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="上架代码">
          <el-input v-model="searchForm.shelfCode" placeholder="请输入上架代码" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item label="群昵称">
          <el-input v-model="searchForm.groupNickname" placeholder="请输入群昵称" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item label="快递类型">
          <el-select v-model="searchForm.isUnknown" placeholder="请选择" clearable style="width: 120px;">
            <el-option label="已知" :value="0"></el-option>
            <el-option label="未知" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回款类型">
          <el-select v-model="searchForm.orderType" placeholder="请选择" clearable style="width: 140px;">
            <el-option label="收到卡预款" :value="1"></el-option>
            <el-option label="正常上拍" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 140px;">
            <el-option label="待收货" :value="0"></el-option>
            <el-option label="已收货" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">查询</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
          <el-button type="success" @click="handleAdd" icon="el-icon-plus">新增运单</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span>运单列表</span>
      </div>

        <el-table :data="tableData" border stripe v-loading="tableLoading">
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="shelfCode" label="上架代码" width="110">
          <template slot-scope="scope">
            {{ scope.row.shelfCode || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="快递单号" min-width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.orderNo || '-' }}</span>
            <el-tag
              v-if="scope.row.orderNo"
              type="primary"
              size="small"
              style="margin-left: 8px; cursor: pointer;"
              @click.native="handleCheckExpress(scope.row.orderNo)"
            >去查快递</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderTypeName" label="回款类型" width="140">
          <template slot-scope="scope">
            <el-tag :type="scope.row.orderType === 1 ? 'warning' : 'primary'" size="small">
              {{ scope.row.orderTypeName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="快递类型" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isUnknown === 1" type="info" size="small">未知</el-tag>
            <el-tag v-else type="success" size="small">已知</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="small">
              {{ scope.row.statusName }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="群昵称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatGroupNickname(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="receiverAddress" label="收货地址" min-width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.receiverAddress">{{ scope.row.receiverName }} {{ scope.row.receiverPhone }} {{ scope.row.receiverAddress }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="运单图片" width="100">
          <template slot-scope="scope">
            <div v-if="getImageList(scope.row.imageUrls).length > 0" class="table-image-btn" @click="openPreview(getImageList(scope.row.imageUrls), 0)">
              <i class="el-icon-picture-outline"></i>
              <span>查看 ({{ getImageList(scope.row.imageUrls).length }})</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="收货照片" width="100">
          <template slot-scope="scope">
            <div v-if="getImageList(scope.row.receiveImageUrls).length > 0" class="table-image-btn" @click="openPreview(getImageList(scope.row.receiveImageUrls), 0)">
              <i class="el-icon-picture-outline"></i>
              <span>查看 ({{ getImageList(scope.row.receiveImageUrls).length }})</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        layout="total, prev, pager, next"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增运单对话框 -->
    <el-dialog title="新增运单" :visible.sync="addDialogVisible" width="600px" @close="handleAddDialogClose">
      <el-form :model="addForm" :rules="addRules" ref="addFormRef" label-width="100px">
        <el-form-item label="快递类型" prop="isUnknown">
          <el-radio-group v-model="addForm.isUnknown">
            <el-radio :label="0">已知</el-radio>
            <el-radio :label="1">未知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="快递单号" prop="orderNo">
          <el-input v-model="addForm.orderNo" placeholder="请输入快递单号"></el-input>
        </el-form-item>
        <template v-if="addForm.isUnknown === 0">
          <el-form-item label="所属用户" prop="userId">
            <el-select
              v-model="addForm.userId"
              filterable
              clearable
              placeholder="请搜索并选择用户"
              style="width: 100%;"
              @change="onUserChange"
            >
              <el-option
                v-for="u in userList"
                :key="u.id"
                :label="u.displayName"
                :value="u.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上架代码" prop="shelfCode">
            <el-select
              v-model="addForm.shelfCode"
              placeholder="请选择或输入上架代码"
              style="width: 100%;"
              filterable
              allow-create
              default-first-option
              clearable
              @change="onAddShelfCodeChange"
            >
              <el-option
                v-for="item in addShelfCodeOptions"
                :key="item.code + '-' + item.userId"
                :label="item.label"
                :value="item.code"
              ></el-option>
            </el-select>
            <div class="address-group-hint">所属用户与上架代码双向联动，选择任一方将自动填充另一方</div>
          </el-form-item>
          <el-form-item label="收货地址" prop="addressId">
            <el-select
              v-model="addForm.addressId"
              placeholder="请选择收货地址"
              style="width: 100%;"
              :disabled="!addForm.userId"
            >
              <el-option
                v-for="addr in allAddresses"
                :key="addr.id"
                :label="addr.receiverName + ' ' + addr.phone + ' ' + addr.province + addr.city + addr.district + addr.detailAddress"
                :value="addr.id"
              ></el-option>
            </el-select>
            <div v-if="addForm.userGroupNickname" class="address-group-hint">
              <span>（{{ addForm.userGroupNickname }}）</span>
            </div>
          </el-form-item>
          <el-form-item label="回款类型" prop="orderType">
            <el-radio-group v-model="addForm.orderType">
              <el-radio :label="1">收到卡预款</el-radio>
              <el-radio :label="2">正常上拍</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <el-form-item label="快递状态" prop="status">
          <el-radio-group v-model="addForm.status">
            <el-radio :label="0">待收货</el-radio>
            <el-radio :label="1">已收货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签收照片" v-if="addForm.status === 1 && addForm.isUnknown === 1">
          <div class="multi-upload-wrap">
            <div
              v-for="(url, idx) in addForm.receiveImageUrls"
              :key="idx"
              class="uploaded-thumb"
            >
              <el-image :src="url" fit="cover" class="thumb-img" :preview-src-list="addForm.receiveImageUrls" />
              <div class="thumb-delete" @click="removeAddImage(idx, 'receiveImageUrls')">
                <i class="el-icon-close"></i>
              </div>
            </div>
            <el-upload
              class="express-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :before-upload="(file) => beforeUploadMulti(file, 'add', 'receiveImageUrls')"
              :on-success="(res) => handleUploadSuccessMulti(res, 'add', 'receiveImageUrls')"
              :on-error="handleUploadError"
              accept="image/*"
            >
              <i class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </div>
          <div class="upload-tip-text">点击图片右上角删除</div>
        </el-form-item>
        <el-form-item label="运单图片" v-if="addForm.isUnknown === 0">
          <div class="multi-upload-wrap">
            <div
              v-for="(url, idx) in addForm.imageUrls"
              :key="idx"
              class="uploaded-thumb"
            >
              <el-image :src="url" fit="cover" class="thumb-img" :preview-src-list="addForm.imageUrls" />
              <div class="thumb-delete" @click="removeAddImage(idx)">
                <i class="el-icon-close"></i>
              </div>
            </div>
              <el-upload
                class="express-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :before-upload="(file) => beforeUploadMulti(file, 'add', 'imageUrls')"
              :on-success="(res) => handleUploadSuccessMulti(res, 'add', 'imageUrls')"
              :on-error="handleUploadError"
              accept="image/*"
            >
              <i class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </div>
          <div class="upload-tip-text">点击图片右上角删除</div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" :rows="3" placeholder="请输入备注（选填）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddSubmit" :loading="addSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 编辑对话框 -->
    <el-dialog title="编辑运单" :visible.sync="editDialogVisible" width="600px" @close="handleEditDialogClose">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
        <el-form-item label="快递类型" prop="isUnknown">
          <el-radio-group v-model="editForm.isUnknown" @change="onEditIsUnknownChange">
            <el-radio :label="0">已知</el-radio>
            <el-radio :label="1">未知</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="快递单号" prop="orderNo">
          <el-input v-model="editForm.orderNo" placeholder="请输入快递单号"></el-input>
        </el-form-item>
        <template v-if="editForm.isUnknown === 0">
          <el-form-item label="所属用户">
            <el-select
              v-model="editForm.userId"
              filterable
              placeholder="请搜索并选择用户"
              style="width: 100%;"
              @change="onEditUserChange"
            >
              <el-option
                v-for="u in userList"
                :key="u.id"
                :label="u.displayName"
                :value="u.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收货地址">
            <el-select
              v-model="editForm.addressId"
              placeholder="请选择收货地址"
              style="width: 100%;"
            >
              <el-option
                v-for="addr in allAddresses"
                :key="addr.id"
                :label="addr.receiverName + ' ' + addr.phone + ' ' + addr.province + addr.city + addr.district + addr.detailAddress"
                :value="addr.id"
              ></el-option>
            </el-select>
            <div v-if="editForm.userGroupNickname" class="address-group-hint">
              <span>（{{ editForm.userGroupNickname }}）</span>
            </div>
          </el-form-item>
          <el-form-item label="上架代码">
            <el-select
              v-model="editForm.shelfCode"
              placeholder="请选择或输入上架代码"
              style="width: 100%;"
              filterable
              allow-create
              default-first-option
              clearable
            >
              <el-option
                v-for="code in shelfCodeOptions"
                :key="code"
                :label="code"
                :value="code"
              ></el-option>
            </el-select>
            <div v-if="editForm.shelfCode && !shelfCodeOptions.includes(editForm.shelfCode)" class="address-group-hint">
              <span>（自定义上架代码）</span>
            </div>
          </el-form-item>
          <el-form-item label="回款类型" prop="orderType">
            <el-radio-group v-model="editForm.orderType">
              <el-radio :label="1">收到卡预款</el-radio>
              <el-radio :label="2">正常上拍</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="运单图片" v-if="editForm.isUnknown === 0">
            <div class="multi-upload-wrap">
              <div
                v-for="(url, idx) in editForm.imageUrls"
                :key="idx"
                class="uploaded-thumb"
              >
                <el-image :src="url" fit="cover" class="thumb-img" :preview-src-list="editForm.imageUrls" />
                <div class="thumb-delete" @click="removeEditImage(idx)">
                  <i class="el-icon-close"></i>
                </div>
              </div>
              <el-upload
                class="express-uploader"
                :action="uploadUrl"
                :headers="uploadHeaders"
                :show-file-list="false"
                :before-upload="(file) => beforeUploadMulti(file, 'edit', 'imageUrls')"
                :on-success="(res) => handleUploadSuccessMulti(res, 'edit', 'imageUrls')"
                :on-error="handleUploadError"
                accept="image/*"
              >
                <i class="el-icon-plus uploader-icon"></i>
              </el-upload>
            </div>
            <div class="upload-tip-text">点击图片右上角删除</div>
          </el-form-item>
        </template>
        <el-form-item label="快递状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="0">待收货</el-radio>
            <el-radio :label="1">已收货</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="收货照片" prop="receiveImageUrl" v-if="editForm.status === 1">
          <div class="multi-upload-wrap">
            <div
              v-for="(url, idx) in editForm.receiveImageUrls"
              :key="idx"
              class="uploaded-thumb"
            >
              <el-image :src="url" fit="cover" class="thumb-img" :preview-src-list="editForm.receiveImageUrls" />
              <div class="thumb-delete" @click="removeEditImage(idx, 'receiveImageUrls')">
                <i class="el-icon-close"></i>
              </div>
            </div>
            <el-upload
              class="express-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :before-upload="(file) => beforeUploadMulti(file, 'edit', 'receiveImageUrls')"
              :on-success="(res) => handleUploadSuccessMulti(res, 'edit', 'receiveImageUrls')"
              :on-error="handleUploadError"
              accept="image/*"
            >
              <i class="el-icon-plus uploader-icon"></i>
            </el-upload>
          </div>
          <div class="upload-tip-text">点击图片右上角删除</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEditSubmit" :loading="editSubmitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看详情对话框 -->
    <el-dialog title="运单详情" :visible.sync="viewDialogVisible" width="600px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="ID">{{ viewData.id }}</el-descriptions-item>
        <el-descriptions-item label="快递单号">{{ viewData.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="快递类型">
          <el-tag v-if="viewData.isUnknown === 1" type="info" size="small">未知</el-tag>
          <el-tag v-else :type="viewData.orderType === 1 ? 'warning' : 'primary'" size="small">
            {{ viewData.orderTypeName }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="viewData.status === 1 ? 'success' : 'warning'" size="small">
            {{ viewData.statusName }}
          </el-tag>
        </el-descriptions-item>
        <template v-if="viewData.isUnknown !== 1">
          <el-descriptions-item label="用户ID">{{ viewData.userId }}</el-descriptions-item>
          <el-descriptions-item label="群昵称">{{ formatGroupNickname(viewData) }}</el-descriptions-item>
          <el-descriptions-item label="上架代码">{{ viewData.shelfCode || '-' }}</el-descriptions-item>
          <el-descriptions-item label="收货地址" :span="2" v-if="viewData.receiverAddress">
            {{ viewData.receiverName }} {{ viewData.receiverPhone }} {{ viewData.receiverAddress }}
          </el-descriptions-item>
          <el-descriptions-item label="收货地址" :span="2" v-else>-</el-descriptions-item>
        </template>
        <el-descriptions-item label="备注" :span="2">{{ viewData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="运单图片" :span="2">
          <template v-if="getImageList(viewData.imageUrls).length > 0">
            <div class="dialog-image-btns">
              <span class="dialog-image-btn" @click="openPreview(getImageList(viewData.imageUrls), 0)">
                <i class="el-icon-picture-outline"></i>
                <span>查看 ({{ getImageList(viewData.imageUrls).length }})</span>
              </span>
            </div>
          </template>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="收货照片" :span="2">
          <template v-if="getImageList(viewData.receiveImageUrls).length > 0">
            <div class="dialog-image-btns">
              <span class="dialog-image-btn" @click="openPreview(getImageList(viewData.receiveImageUrls), 0)">
                <i class="el-icon-picture-outline"></i>
                <span>查看 ({{ getImageList(viewData.receiveImageUrls).length }})</span>
              </span>
            </div>
          </template>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ formatDate(viewData.createTime) }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ formatDate(viewData.updateTime) }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <!-- 图片预览 -->
    <el-dialog
      title="图片预览"
      :visible.sync="previewVisible"
      width="680px"
      append-to-body
      :show-close="true"
      @closed="onPreviewClosed"
    >
      <div v-if="previewUrlList.length > 0" class="preview-container">
        <!-- 计数 -->
        <div class="preview-counter">{{ previewIndex + 1 }} / {{ previewUrlList.length }}</div>

        <!-- 大图 -->
        <div class="preview-main">
          <el-button
            class="preview-nav-btn preview-nav-btn--prev"
            icon="el-icon-arrow-left"
            circle
            :disabled="previewIndex === 0"
            @click="previewIndex--"
          ></el-button>
          <el-image
            :src="previewUrlList[previewIndex]"
            style="width: 100%; height: 420px;"
            fit="contain"
            :preview-src-list="previewUrlList"
            :initial-index="previewIndex"
          ></el-image>
          <el-button
            class="preview-nav-btn preview-nav-btn--next"
            icon="el-icon-arrow-right"
            circle
            :disabled="previewIndex === previewUrlList.length - 1"
            @click="previewIndex++"
          ></el-button>
        </div>

        <!-- 缩略图导航 -->
        <div class="preview-thumbs">
          <div
            v-for="(url, idx) in previewUrlList"
            :key="idx"
            :class="['preview-thumb', { 'is-active': idx === previewIndex }]"
            @click="previewIndex = idx"
          >
            <el-image :src="url" fit="cover" style="width: 100%; height: 100%;"></el-image>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getExpressList, getExpress, addExpress, updateExpress, deleteExpress, uploadExpressImage, getExpressUsers, getAllAddresses, getShelfCodes, checkExpressOrderNo, getUserList } from '@/api'

export default {
  name: 'ExpressManagement',
  data() {
    return {
      searchForm: {
        orderNo: '',
        shelfCode: '',
        groupNickname: '',
        isUnknown: null,
        orderType: null,
        status: null
      },
      tableData: [],
      tableLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      editDialogVisible: false,
      editSubmitLoading: false,
      uploading: false,
      addDialogVisible: false,
      addSubmitLoading: false,
      userList: [],
      fullUserMap: {},
      allShelfCodeOptions: [],
      allAddresses: [],
      shelfCodeOptions: [],
      addLinkSource: '',
      addForm: {
        userId: null,
        userGroupNickname: '',
        isUnknown: 0,
        orderNo: '',
        orderType: 1,
        shelfCode: '',
        shelfCodeInput: '',
        status: 0,
        remark: '',
        imageUrls: [],
        addressId: null,
        receiveImageUrls: []
      },
      addRules: {
        orderNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          { validator: (rule, value, callback) => this.validateOrderNo(rule, value, callback, 'add'), trigger: 'blur' }
        ]
      },
      editForm: {
        id: null,
        userId: null,
        addressId: null,
        userGroupNickname: '',
        isUnknown: 0,
        orderNo: '',
        orderType: 1,
        shelfCode: '',
        shelfCodeInput: '',
        status: 0,
        remark: '',
        imageUrls: [],
        receiveImageUrls: [],
        receiverAddress: ''
      },
      editRules: {
        orderNo: [
          { required: true, message: '请输入快递单号', trigger: 'blur' },
          { validator: (rule, value, callback) => this.validateOrderNo(rule, value, callback, 'edit'), trigger: 'blur' }
        ]
      },
      viewDialogVisible: false,
      viewData: null,
      previewVisible: false,
      previewUrl: '',
      previewUrlList: [],
      previewIndex: 0
    }
  },
  computed: {
    uploadUrl() {
      const baseURL = process.env.VUE_APP_BASE_API || window.location.origin
      return baseURL + '/api/admin/express/upload/image'
    },
    uploadHeaders() {
      const token = localStorage.getItem('token')
      return {
        Authorization: token ? `Bearer ${token}` : ''
      }
    },
    addShelfCodeOptions() {
      if (this.addForm.userId) {
        const user = this.getFullUser(this.addForm.userId)
        const name = user?.groupNickname || user?.nickname || ''
        const codes = this.shelfCodeOptions.length > 0
          ? this.shelfCodeOptions
          : this.parseUserShelfCodes(user)
        return codes.map(code => ({
          code,
          userId: this.addForm.userId,
          label: name ? `${code}（${name}）` : code
        }))
      }
      return this.allShelfCodeOptions
    }
  },
  watch: {
    'addForm.userId'(newVal) {
      if (!newVal) {
        this.addForm.userGroupNickname = ''
        this.addForm.addressId = null
        this.userAddresses = []
      }
    }
  },
  created() {
    this.loadData()
    this.loadUsersWithAddresses()
  },
  methods: {
    formatGroupNickname(row) {
      if (!row) return '-'
      const nickname = row.groupNickname != null ? String(row.groupNickname).trim() : ''
      if (nickname) return nickname
      return row.userName || '-'
    },
    handleCheckExpress(orderNo) {
      navigator.clipboard.writeText(orderNo).then(() => {
        this.$message.success('快递单号已复制，请等待界面自动跳转')
      }).catch(() => {
        this.$message.info('快递单号已复制')
      })
      setTimeout(() => {
        window.open('https://m.kuaidi100.com/mexpress/home?coname=uc', '_blank')
      }, 2000)
    },
    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          ...this.searchForm
        }
        const res = await getExpressList(params)
        this.tableData = res.data.list || []
        this.pagination.total = res.data.total || 0
      } catch (e) {
        console.error(e)
      } finally {
        this.tableLoading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleAdd() {
      this.resetAddForm()
      this.addDialogVisible = true
    },
    async loadUsersWithAddresses() {
      try {
        const [usersRes, addrsRes, fullUsersRes] = await Promise.all([
          getExpressUsers(),
          getAllAddresses(),
          getUserList({ pageNum: 1, pageSize: 1000, status: 1 })
        ])
        this.userList = usersRes.data || []
        this.fullUserMap = {}
        ;(fullUsersRes.data?.list || []).forEach(user => {
          this.fullUserMap[user.id] = user
        })
        this.allAddresses = addrsRes.data || []
        this.buildAllShelfCodeOptions()
      } catch (e) {
        console.error(e)
      }
    },
    getFullUser(userId) {
      if (!userId) return null
      return this.fullUserMap[userId] || this.userList.find(u => u.id === userId) || null
    },
    parseUserShelfCodes(user) {
      if (!user) return []
      const codes = []
      const appendCodes = (raw) => {
        if (!raw) return
        String(raw).split(',').forEach(code => {
          const trimmed = code.trim()
          if (trimmed) codes.push(trimmed)
        })
      }
      appendCodes(user.mailingShelfCode)
      appendCodes(user.crowdfundingShelfCode)
      return [...new Set(codes)]
    },
    buildAllShelfCodeOptions() {
      const options = []
      const seen = new Set()
      Object.values(this.fullUserMap).forEach(user => {
        const displayName = user.groupNickname || user.nickname || user.username || ''
        this.parseUserShelfCodes(user).forEach(code => {
          if (seen.has(code)) return
          seen.add(code)
          options.push({
            code,
            userId: user.id,
            label: displayName ? `${code}（${displayName}）` : code
          })
        })
      })
      this.allShelfCodeOptions = options
    },
    resetAddForm() {
      this.addForm = {
        userId: null,
        userGroupNickname: '',
        isUnknown: 0,
        orderNo: '',
        orderType: 1,
        shelfCode: '',
        shelfCodeInput: '',
        status: 0,
        remark: '',
        imageUrls: [],
        addressId: null,
        receiveImageUrls: []
      }
      this.shelfCodeOptions = []
      this.addLinkSource = ''
    },
    validateOrderNo(rule, value, callback, mode) {
      const trimmed = (value || '').trim()
      if (!trimmed) {
        callback()
        return
      }
      const excludeId = mode === 'edit' ? (this.editForm.id || null) : null
      checkExpressOrderNo(trimmed, excludeId).then(res => {
        if (res.code === 200 && res.data && res.data.exists) {
          callback(new Error('该快递单号已存在'))
        } else {
          callback()
        }
      }).catch(() => {
        callback()
      })
    },
    async onUserChange(val) {
      if (val) {
        this.addLinkSource = 'user'
        const user = this.getFullUser(val)
        this.addForm.userGroupNickname = user ? (user.groupNickname || '') : ''
        this.addForm.addressId = null
        this.addForm.shelfCode = ''
        await this.loadShelfCodes(val, '', true)
        return
      }
      this.addLinkSource = ''
      this.addForm.userGroupNickname = ''
      this.addForm.addressId = null
      this.addForm.shelfCode = ''
      this.shelfCodeOptions = []
    },
    async onAddShelfCodeChange(code) {
      if (!code) {
        if (this.addLinkSource === 'shelfCode') {
          this.addForm.userId = null
          this.addForm.userGroupNickname = ''
          this.addForm.addressId = null
          this.shelfCodeOptions = []
        }
        this.addLinkSource = ''
        return
      }
      if (this.addForm.userId) {
        const userCodes = this.shelfCodeOptions.length > 0
          ? this.shelfCodeOptions
          : this.parseUserShelfCodes(this.getFullUser(this.addForm.userId))
        if (userCodes.includes(code)) {
          return
        }
      }
      this.addLinkSource = 'shelfCode'
      const userId = await this.findUserIdByShelfCode(code)
      if (!userId) {
        this.$message.warning('未找到该上架代码对应的用户')
        this.addForm.shelfCode = ''
        this.addLinkSource = ''
        return
      }
      this.addForm.userId = userId
      const user = this.getFullUser(userId)
      this.addForm.userGroupNickname = user ? (user.groupNickname || '') : ''
      this.addForm.addressId = null
      await this.loadShelfCodes(userId, code)
    },
    async findUserIdByShelfCode(code) {
      const trimmed = (code || '').trim()
      if (!trimmed) return null
      const matched = this.allShelfCodeOptions.find(item => item.code === trimmed)
      if (matched) return matched.userId
      try {
        const res = await getUserList({ pageNum: 1, pageSize: 20, shelfCode: trimmed, status: 1 })
        const list = res.data?.list || []
        if (list.length > 0) return list[0].id
      } catch (e) {
        console.error(e)
      }
      return null
    },
    onEditUserChange(val) {
      if (val) {
        const user = this.userList.find(u => u.id === val)
        this.editForm.userGroupNickname = user ? (user.groupNickname || '') : ''
        this.loadEditShelfCodesForForm()
      } else {
        this.editForm.userGroupNickname = ''
        this.shelfCodeOptions = []
        this.editForm.shelfCode = ''
      }
    },
    async loadEditShelfCodesForForm() {
      if (!this.editForm.userId) return
      try {
        const res = await getShelfCodes(this.editForm.userId)
        this.shelfCodeOptions = res.data || []
        if (this.editForm.shelfCode && !this.shelfCodeOptions.includes(this.editForm.shelfCode)) {
          this.shelfCodeOptions.push(this.editForm.shelfCode)
        }
      } catch (e) {
        console.error(e)
        this.shelfCodeOptions = []
      }
    },
    onEditIsUnknownChange(val) {
      if (val === 1) {
        this.editForm.userId = null
        this.editForm.addressId = null
        this.editForm.userGroupNickname = ''
        this.editForm.shelfCode = ''
        this.shelfCodeOptions = []
      }
    },
    async loadShelfCodes(userId, keepShelfCode = '', autoSelectFirst = false) {
      try {
        const res = await getShelfCodes(userId)
        let codes = res.data || []
        const user = this.getFullUser(userId)
        const fallbackCodes = this.parseUserShelfCodes(user)
        if (codes.length === 0 && fallbackCodes.length > 0) {
          codes = fallbackCodes
        }
        this.shelfCodeOptions = codes
        if (keepShelfCode) {
          this.addForm.shelfCode = keepShelfCode
          if (!this.shelfCodeOptions.includes(keepShelfCode)) {
            this.shelfCodeOptions.push(keepShelfCode)
          }
        } else if (autoSelectFirst && codes.length > 0) {
          this.addForm.shelfCode = codes[0]
        }
      } catch (e) {
        console.error(e)
        const fallbackCodes = this.parseUserShelfCodes(this.getFullUser(userId))
        this.shelfCodeOptions = fallbackCodes
        if (autoSelectFirst && fallbackCodes.length > 0) {
          this.addForm.shelfCode = fallbackCodes[0]
        } else {
          this.shelfCodeOptions = []
        }
      }
    },
    handleAddDialogClose() {
      this.$refs.addFormRef.resetFields()
      this.uploading = false
    },
    async handleAddSubmit() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        if (this.addForm.isUnknown === 0) {
          if (!this.addForm.userId && !this.addForm.shelfCode) {
            this.$message.warning('请选择所属用户或上架代码')
            return
          }
          if (!this.addForm.userId && this.addForm.shelfCode) {
            const userId = await this.findUserIdByShelfCode(this.addForm.shelfCode)
            if (!userId) {
              this.$message.warning('未找到该上架代码对应的用户')
              return
            }
            this.addForm.userId = userId
          }
        }
        this.addSubmitLoading = true
        try {
          await addExpress({
            userId: this.addForm.isUnknown === 0 ? this.addForm.userId : null,
            orderNo: this.addForm.orderNo,
            orderType: this.addForm.isUnknown === 0 ? this.addForm.orderType : 1,
            shelfCode: this.addForm.isUnknown === 0 ? this.addForm.shelfCode : null,
            remark: this.addForm.remark,
            imageUrls: this.addForm.isUnknown === 0 ? this.addForm.imageUrls.join(',') : null,
            addressId: this.addForm.isUnknown === 0 ? this.addForm.addressId : null,
            isUnknown: this.addForm.isUnknown,
            status: this.addForm.isUnknown === 1 ? this.addForm.status : 0,
            receiveImageUrls: this.addForm.isUnknown === 1 ? this.addForm.receiveImageUrls.join(',') : null
          })
          this.$message.success('新增成功')
          this.addDialogVisible = false
          this.loadData()
        } catch (e) {
          this.$message.error(e.message || '新增失败')
        } finally {
          this.addSubmitLoading = false
        }
      })
    },
    handleReset() {
      this.searchForm = {
        orderNo: '',
        shelfCode: '',
        groupNickname: '',
        isUnknown: null,
        orderType: null,
        status: null
      }
      this.handleSearch()
    },
    handlePageChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    async handleEdit(row) {
      try {
        const res = await getExpress(row.id)
        const data = res.data
        this.editForm = {
          id: data.id,
          userId: data.userId,
          addressId: data.addressId,
          userGroupNickname: data.groupNickname || '',
          isUnknown: data.isUnknown != null ? data.isUnknown : 0,
          orderNo: data.orderNo,
          orderType: data.orderType,
          shelfCode: data.shelfCode || '',
          shelfCodeInput: '',
          status: data.status,
          remark: data.remark || '',
          imageUrls: this.getImageList(data.imageUrls || data.imageUrl || ''),
          receiveImageUrls: this.getImageList(data.receiveImageUrls || data.receiveImageUrl || ''),
          receiverAddress: data.receiverAddress || ''
        }
        if (data.isUnknown !== 1 && data.userId) {
          await this.loadEditShelfCodes(data.userId, data.shelfCode)
        }
        this.editDialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    async loadEditShelfCodes(userId, currentShelfCode) {
      try {
        const res = await getShelfCodes(userId)
        this.shelfCodeOptions = res.data || []
        if (currentShelfCode && !this.shelfCodeOptions.includes(currentShelfCode)) {
          this.shelfCodeOptions.push(currentShelfCode)
        }
      } catch (e) {
        console.error(e)
        this.shelfCodeOptions = []
      }
    },
    handleEditDialogClose() {
      this.$refs.editFormRef.resetFields()
      this.uploading = false
    },
    beforeUpload(file, fieldKey) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        return false
      }
      this.uploading = fieldKey || 'imageUrl'
      return true
    },
    handleUploadSuccess(res, fieldKey) {
      this.uploading = false
      const targetKey = fieldKey || 'imageUrl'
      if (res.code === 200 && res.data && res.data.url) {
        if (this.addDialogVisible) {
          this.addForm[targetKey] = res.data.url
        } else {
          this.editForm[targetKey] = res.data.url
        }
        this.$message.success('图片上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    handleUploadError(err) {
      this.uploading = false
      console.error(err)
      this.$message.error('上传失败，请重试')
    },
    handlePreviewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    },
    async handleEditSubmit() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (valid) {
          this.editSubmitLoading = true
          try {
            const isUnknown = parseInt(this.editForm.isUnknown, 10)
            await updateExpress(this.editForm.id, {
              orderNo: this.editForm.orderNo,
              userId: this.editForm.userId,
              orderType: this.editForm.orderType,
              status: this.editForm.receiveImageUrls.length > 0 ? 1 : this.editForm.status,
              shelfCode: isUnknown === 0 ? this.editForm.shelfCode : null,
              remark: this.editForm.remark,
              imageUrls: isUnknown === 0 ? this.editForm.imageUrls.join(',') : null,
              receiveImageUrls: this.editForm.receiveImageUrls.join(',') || null,
              addressId: isUnknown === 0 ? this.editForm.addressId : null,
              isUnknown: isUnknown
            })
            this.$message.success('更新成功')
            this.editDialogVisible = false
            this.loadData()
          } catch (e) {
            console.error(e)
          } finally {
            this.editSubmitLoading = false
          }
        }
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该运单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteExpress(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          console.error(e)
        }
      }
    },
    async handleView(row) {
      try {
        const res = await getExpress(row.id)
        this.viewData = res.data
        this.viewDialogVisible = true
      } catch (e) {
        console.error(e)
      }
    },
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleString()
    },
    // 解析图片列表，兼容数组 / 逗号字符串 / 单字符串
    getImageList(field) {
      if (!field) return []
      if (Array.isArray(field)) return field
      const trimmed = String(field).trim()
      if (!trimmed) return []
      if (trimmed.startsWith('[')) {
        try { return JSON.parse(trimmed) } catch { return [] }
      }
      if (trimmed.includes(',')) return trimmed.split(',').map(u => u.trim()).filter(u => u)
      return [trimmed]
    },
    // 多图预览
    openPreview(urls, index = 0) {
      this.previewUrlList = Array.isArray(urls) ? urls : [urls]
      this.previewIndex = index
      this.previewVisible = true
    },
    onPreviewClosed() {
      this.previewUrlList = []
      this.previewIndex = 0
    },
    // 多图上传前置校验
    beforeUploadMulti(file, dialog, fieldKey) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) { this.$message.error('只能上传图片文件'); return false }
      if (!isLt10M) { this.$message.error('图片大小不能超过 10MB'); return false }
      return true
    },
    // 多图上传成功
    handleUploadSuccessMulti(res, dialog, fieldKey) {
      if (res.code === 200 && res.data && res.data.url) {
        const formKey = dialog === 'add' ? 'addForm' : 'editForm'
        this[formKey][fieldKey].push(res.data.url)
        this.$message.success('图片上传成功')
      } else {
        this.$message.error(res.message || '上传失败')
      }
    },
    // 删除新增表单中的图片
    removeAddImage(index, fieldKey = 'imageUrls') {
      this.addForm[fieldKey].splice(index, 1)
    },
    // 删除编辑表单中的图片
    removeEditImage(index, fieldKey = 'imageUrls') {
      this.editForm[fieldKey].splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.express-management {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.table-card {
  min-height: 500px;
}

.upload-wrap {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}

.express-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s;

    &:hover {
      border-color: #FF8C00;
    }
  }

  .uploaded-img {
    width: 148px;
    height: 148px;
    object-fit: cover;
    display: block;
  }

  .uploader-icon {
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    font-size: 28px;
    color: #8c939d;
  }
}

.upload-tip {
  padding-top: 80px;

  .uploading-text {
    color: #FF8C00;
  }

  .hint-text {
    color: #999;
    font-size: 12px;
  }
}

.multi-upload-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.uploaded-thumb {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #ebeef5;

  .thumb-img {
    width: 100%;
    height: 100%;
  }

  .thumb-delete {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 22px;
    height: 22px;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #fff;
    font-size: 12px;
    z-index: 2;
  }
}

.multi-upload-wrap .express-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.2s;

    &:hover {
      border-color: #FF8C00;
    }
  }

  .uploader-icon {
    font-size: 28px;
    color: #8c939d;
  }
}

.upload-tip-text {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.table-image-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.table-image-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #f0f7ff;
  color: #409EFF;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #b3d8fd;
  transition: all 0.2s;

  &:hover {
    background: #ecf5ff;
    color: #66b1ff;
  }
}

.dialog-image-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dialog-image-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  background: #f0f7ff;
  color: #409EFF;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  border: 1px solid #b3d8fd;
  transition: all 0.2s;

  &:hover {
    background: #ecf5ff;
    color: #66b1ff;
  }
}

.preview-container {
  user-select: none;
}

.preview-counter {
  text-align: center;
  font-size: 14px;
  color: #909399;
  margin-bottom: 12px;
}

.preview-main {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 420px;
  background: #f5f7fa;
  border-radius: 6px;
  overflow: hidden;

  .el-image {
    max-width: 100%;
    max-height: 100%;
  }
}

.preview-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  background: rgba(255, 255, 255, 0.9) !important;
  border-color: #dcdfe6 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  &--prev { left: 16px; }
  &--next { right: 16px; }

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 1) !important;
    border-color: #FF8C00 !important;
    color: #FF8C00 !important;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.preview-thumbs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 16px;
  max-height: 100px;
  overflow-x: auto;
  padding: 4px 0;
}

.preview-thumb {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  border: 2px solid transparent;
  cursor: pointer;
  opacity: 0.65;
  transition: all 0.2s;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
    border-color: #d0d0d0;
  }

  &.is-active {
    border-color: #FF8C00;
    opacity: 1;
    box-shadow: 0 0 0 2px rgba(255, 140, 0, 0.2);
  }
}

.image-more {
  font-size: 12px;
  color: #909399;
  margin-left: 2px;
}

.view-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.address-display {
  color: #606266;
  line-height: 1.6;
  font-size: 13px;
}

.address-group-hint {
  color: #E6A23C;
  font-size: 12px;
  margin-top: 4px;
}
</style>
